import { render, staticRenderFns } from "./InfoPeopleRankingFilter.vue?vue&type=template&id=5683f72f"
import script from "./InfoPeopleRankingFilter.vue?vue&type=script&lang=js"
export * from "./InfoPeopleRankingFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports